import type { CapsuleParty } from "../interfaces/CapsuleParty";
import { API } from "./BaseAPI";

//Test sites are Blayney (35251338) and Ballina (47794622)
export const AnnualSupportHoursTag = 782029;
export const CommencementDateTag = 782021;
export const ContractTerm = 782019;
export const SubscriptionStartDate = 818219;

export function GetCapsulePartyPeopleByID(id: string) {
	return API()
		.get<{ parties: CapsuleParty[] }>(`/parties/${id}/people?perPage=100`, {
			method: "GET",
		})
		.then((res) => {
			return res.data;
		});
}

export function GetCapsulePartyByID(id: string) {
	return API()
		.get<{ party: CapsuleParty }>(`/parties/${id}?embed=fields`, {
			method: "GET",
		})
		.then((res) => {
			return res.data;
		});
}
